module.exports = __webpack_public_path__ + "static/media/TechNeuroscienceIntersections.4090e420.png";